export default __webpack_public_path__ + "static/media/check-mark-3.2571e9db.svg";